import React from 'react';
import {InPageAlert} from '@snsw-gel/react';

export interface TSPOutageAlertProps {
    readonly title: string;
    /** List of paragraphs of copy to be displayed to the user */
    readonly messages: readonly string[];
    readonly variant: 'warning' | 'info' | 'error';
}

export const TSPOutageAlert: React.FC<TSPOutageAlertProps> = (
    {
        title,
        messages,
        variant = 'warning',
    },
) => <InPageAlert
    title={title}
    variant={variant}
>
    {messages.map((message) => <p key={message}>{message}</p>)}
</InPageAlert>;
